<template>
  <div class="block__actions" style="background-color: #fff;">
    <!-- 选择所有事件 -->
    <ChooseEvent
      v-if="eventsAllVisible"
      :visible="eventsAllVisible"
      :category="nowCategory"
      @cancel="hideEventsAll"
      @create="selectEvent"
    />

    <!-- 搜索窗口 -->
    <div class="search">
      <a-input placeholder="搜索分类名、描述" v-model="search">
        <a-icon slot="prefix" type="search" />
      </a-input>
    </div>

    <!-- 分类列表 -->
    <div class="block__actions--container">
      <template v-if="categorysTable && categorysTable.length > 0">
        <a-table
          :columns="columns"
          :data-source="categorysTable"
          size="middle"
          :pagination="false"
          :showHeader="false"
          :bordered="false"
          :customRow="customRow"
          :locale="{
            emptyText: '无分类'
          }"
        >
          <template slot="name" slot-scope="text, index">
            <a-tooltip placement="topLeft" class="category__item">
              <template slot="title">
                <span>{{ index.description }}</span>
              </template>
              <span
                class="category__item--color"
                :style="`background-color: ${index.color}`"
                v-if="index.type === 'category'"
              ></span>
              <span v-if="index.icon">{{ index.icon }}</span>
              {{ index.name }}
            </a-tooltip>
          </template>
          <template slot="action" slot-scope="text, record" style="margin: 0">
            <a-tooltip placement="left" class="category__item" v-if="text">
              <template slot="title">
                <span>更多事件</span>
              </template>
              <a-icon
                type="right-square"
                class="more"
                @click.stop="showEventsAll(record.category)"
              />
            </a-tooltip>
          </template>
        </a-table>
      </template>

      <!-- 空数据提示 -->
      <template v-else>
        <a-result :sub-title="search ? '没有符合条件的分类噢' : '还没有分类噢'">
          <template #icon>
            <a-icon type="smile" theme="twoTone" />
          </template>
          <template #extra>
            <a-button type="dashed" @click="$router.push('/category')">
              去添加分类
            </a-button>
          </template>
        </a-result>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ChooseEvent from "./BlockSelectAllEvent";
const columns = [
  {
    title: "分类",
    dataIndex: "name",
    key: "name",
    ellipsis: true,
    scopedSlots: { customRender: "name" }
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
    align: "right",
    width: 50
  }
];

//点击Table的行添加事件
const customRow = handleClick => {
  return record => {
    return {
      props: {
        test: 10
      },
      on: {
        click: () => {
          // 转发
          handleClick(record);
        } // 点击行
      }
    };
  };
};

export default {
  components: {
    ChooseEvent
  },
  data() {
    return {
      eventsAllVisible: false,
      columns,
      customRow: customRow(this.record),
      search: "",
      nowCategory: ""
    };
  },
  computed: {
    categorysTable() {
      const result = [];
      let count = 0; //计次，用作key，防止key重复
      //遍历所有事件
      for (let category in this.categorys) {
        //获取属性
        const { name, color, description, shortcut, active } = this.categorys[
          category
        ];
        const match =
          active && (name.match(this.search) || description.match(this.search)); //分类是否满足条件

        if (!match) continue; //不满足则查看下一个分类

        // 读取分类
        const categoryTableItem = {
          key: count++,
          category,
          name,
          color,
          description,
          type: "category",
          action: true,
          children: []
        };

        //读取快捷方式
        for (let event of shortcut) {
          if (!event) continue;
          const { name, description, active, icon } = this.events[event]; //注意这里的name, description, active和上面重复
          if (!(name && active)) continue; //判断事件是否存在,如果没有name属性肯定是被删除事件
          const shortcutItem = {
            key: count++,
            category,
            event,
            name,
            icon,
            type: "event",
            description
          };
          categoryTableItem.children.push(shortcutItem);
        }

        if (!categoryTableItem.children.length)
          delete categoryTableItem.children;

        result.push(categoryTableItem);
      }
      return result;
    },
    ...mapGetters(["categorys", "events", "hasChosen"])
  },
  methods: {
    showEventsAll(category) {
      if (!this.hasChosen) {
        this.$message.error("未选择块");
        return;
      }
      this.eventsAllVisible = true;
      this.nowCategory = category;
    },
    hideEventsAll() {
      this.eventsAllVisible = false;
    },
    selectEvent(record) {
      this.eventsAllVisible = false;
      this.record(record);
    },
    record(record) {
      this.setRecord(record);
    },
    ...mapActions(["createCategory", "setRecord"])
  }
};
</script>

<style>
.more {
  cursor: pointer;
  transition: 0.3s;
}

.more:hover {
  color: #40a9ff;
}
.search {
  padding: 2rem 1.5rem;
  margin-bottom: -1rem;
}
.search input {
  border-radius: 10rem;
}
.block__actions {
  /* border-left: 1px solid #dee0e3; */
  background-color: #f8f9fa;
  overflow: auto;
}
.category__item--color {
  display: inline-block;
  height: 1.2rem;
  width: 1.2rem;
  border-radius: 10rem;
  margin-right: 1rem;
}

.category__item {
  /* cursor: pointer; */
  /* display: flex; */
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.ant-table-row-cell-ellipsis {
  user-select: none;
}

.ant-tabs-bar {
  margin: 0;
}
</style>
